<template>
  <div>
    <div>
      <div data-v-d8c6d368>
        <div data-v-d8c6d368="" class="el-card is-never-shadow">
          <div class="el-card__body" style="padding: 10px;">
            <div data-v-d8c6d368="" class="G_Field">
              <div data-v-d8c6d368="" class="Label c_link" style="text-align: center;">
                省份：
              </div>
              <div data-v-d8c6d368="" class="Fields">
                <div data-v-d8c6d368="" class="row" v-if="zsq">
                  <a data-v-d8c6d368="" class="city_link active">{{ shengname }}</a>
                  <button data-v-d8c6d368="" type="button" @click="submit_zsq"
                    class="el-button el-button--default el-button--mini is-round">
                    <span>+ 更多省份</span>
                  </button>
                </div>
                <div data-v-d8c6d368="" class="row" v-if="csq">
                  <a data-v-d8c6d368="" class="city_link active">{{ shengname }}</a>
                  <a data-v-d8c6d368="" v-for="sheng in shengfen" :href="'lists?cid=' + sheng.id"
                    :class="{ 'active': sheng.id === shengids }" class="city_link">{{ sheng.name }}</a>
                  <div data-v-d8c6d368="" class="p-0" style="text-align: left;"><button data-v-d8c6d368=""
                      @click="submit_csq" type="button"
                      class="el-button el-button--default el-button--mini is-round"><span> - 收起</span></button></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div data-v-d8c6d368="" class="el-card is-never-shadow">
          <div class="el-card__body" style="padding: 10px;">
            <div data-v-d8c6d368="" class="G_Field">
              <div data-v-d8c6d368="" class="Label c_link" style="text-align: center;">
                城市：
              </div>
              <div data-v-d8c6d368="" class="Fields">
                <div data-v-d8c6d368="" class="row" v-if="zssq">
                  <a data-v-d8c6d368="" class="city_link active">{{ chengshiname }}</a>
                  <button data-v-d8c6d368="" @click="submit_zssq" type="button"
                    class="el-button el-button--default el-button--mini is-round"><span> + 更多城市</span></button>
                </div>
                <div data-v-d8c6d368="" class="row" v-if="cssq">
                  <a data-v-d8c6d368="" class="city_link active">{{ chengshiname }}</a>
                  <a data-v-d8c6d368="" v-for="shi in chengshi" :href="'lists?cid=' + shi.id"
                    :class="{ 'active': shi.id === chengshiids }" class="city_link">{{ shi.name }}</a>
                  <div data-v-d8c6d368="" class="p-0" style="text-align: left;">
                    <button data-v-d8c6d368="" @click="submit_cssq" type="button"
                      class="el-button el-button--default el-button--mini is-round"><span> - 收起</span></button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="最新发布" :disabled="zuixin" name="1"></el-tab-pane>
        <el-tab-pane label="本周热门" :disabled="benzhou" name="2"></el-tab-pane>
        <el-tab-pane label="本月热门" :disabled="benyue" name="3"></el-tab-pane>
        <el-tab-pane label="上月热门" :disabled="shangyue" name="4"></el-tab-pane>
      </el-tabs>
      <div data-v-63c6a108>
        <div data-v-63c6a108 class="el-row" style="z-index: 0;">
          <div data-v-63c6a108="" v-for="v in top" class="el-col el-col-24 el-col-xs-24 el-col-sm-12 el-col-md-8 el-col-lg-8"><a
              data-v-63c6a108="" :href="'show?id='+v.id" class="">
              <div data-v-63c6a108="" class="el-card is-hover-shadow" style="margin: 0.1rem !important;">
                <div class="el-card__body" style="padding: 0px; height: 160px;">
                  <div data-v-63c6a108="" class="C-InfoCard">
                    <div data-v-63c6a108="" class="Content">
                      <div data-v-63c6a108="" class="Title">{{v.title}}</div>
                      <div data-v-63c6a108="">
                        <div data-v-63c6a108="" class="State">
                          <div data-v-63c6a108=""><svg data-v-73b7ef61="" data-v-63c6a108="" aria-hidden="true"
                              class="svg-icon" style="fill: rgb(153, 153, 153);">
                              <use data-v-73b7ef61="" xlink:href="#icon-time"></use>
                            </svg> <span data-v-63c6a108="">{{v.create_time}}</span></div>
                          &nbsp;&nbsp;
                          <div data-v-63c6a108=""><svg data-v-73b7ef61="" data-v-63c6a108="" aria-hidden="true"
                              class="svg-icon" style="fill: rgb(153, 153, 153);">
                              <use data-v-73b7ef61="" xlink:href="#icon-browse"></use>
                            </svg> <span data-v-63c6a108="">{{v.browse}}</span></div>
                        </div>
                        <div data-v-63c6a108="" class="Desc">{{v.process}}</div>
                      </div>
                      <div data-v-63c6a108="" class="Location">
                        <div data-v-63c6a108="" class="Left"><svg data-v-73b7ef61="" data-v-63c6a108=""
                            aria-hidden="true" class="svg-icon" style="fill: rgb(255, 51, 153);">
                            <use data-v-73b7ef61="" xlink:href="#icon-address"></use>
                          </svg> <span data-v-63c6a108="">{{v.dz}}</span></div>
                        <div data-v-63c6a108="" class="Tags"> </div>
                      </div>
                    </div> <img data-v-63c6a108="" alt="img" :src="v.img" onerror="this.remove()" class="Cover">
                  </div>
                </div>
              </div>
            </a>
          </div>
          <div data-v-63c6a108="" v-for="v in listsdata" class="el-col el-col-24 el-col-xs-24 el-col-sm-12 el-col-md-8 el-col-lg-8"><a
              data-v-63c6a108="" :href="'show?id='+v.id" class="">
              <div data-v-63c6a108="" class="el-card is-hover-shadow" style="margin: 0.1rem !important;">
                <div class="el-card__body" style="padding: 0px; height: 160px;">
                  <div data-v-63c6a108="" class="C-InfoCard">
                    <div data-v-63c6a108="" class="Content">
                      <div data-v-63c6a108="" class="Title">{{v.title}}</div>
                      <div data-v-63c6a108="">
                        <div data-v-63c6a108="" class="State">
                          <div data-v-63c6a108=""><svg data-v-73b7ef61="" data-v-63c6a108="" aria-hidden="true"
                              class="svg-icon" style="fill: rgb(153, 153, 153);">
                              <use data-v-73b7ef61="" xlink:href="#icon-time"></use>
                            </svg> <span data-v-63c6a108="">{{v.create_time}}</span></div>
                          &nbsp;&nbsp;
                          <div data-v-63c6a108=""><svg data-v-73b7ef61="" data-v-63c6a108="" aria-hidden="true"
                              class="svg-icon" style="fill: rgb(153, 153, 153);">
                              <use data-v-73b7ef61="" xlink:href="#icon-browse"></use>
                            </svg> <span data-v-63c6a108="">{{v.browse}}</span></div>
                        </div>
                        <div data-v-63c6a108="" class="Desc">{{v.process}}</div>
                      </div>
                      <div data-v-63c6a108="" class="Location">
                        <div data-v-63c6a108="" class="Left"><svg data-v-73b7ef61="" data-v-63c6a108=""
                            aria-hidden="true" class="svg-icon" style="fill: rgb(255, 51, 153);">
                            <use data-v-73b7ef61="" xlink:href="#icon-address"></use>
                          </svg> <span data-v-63c6a108="">{{v.dz}}</span></div>
                        <div data-v-63c6a108="" class="Tags"> </div>
                      </div>
                    </div> <img data-v-63c6a108="" alt="img" :src="v.img" onerror="this.remove()" class="Cover">
                  </div>
                </div>
              </div>
            </a>
          </div>
        </div>
        <div data-v-c4f3ece2>
          <div data-v-c4f3ece2 class="el-card is-never-shadow" style="margin: 0px;">
              <div class="el-card__body" style="margin: 20px;">
              <el-pagination
                background
                layout="prev, pager, next"
                :total="total"
                :pager-count="5"
                @current-change="pageclick"
                :page-size="24"
                :current-page=currentpage
                >
              </el-pagination>
              </div>
          </div>
      </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'lists',
  data() {
    return {
      zsq: true,
      csq: false,
      zssq: true,
      cssq: false,

      shengname: '全部',
      shengids: null,
      shengfen: [],
      chengshiname: '全部',
      chengshiids: null,
      chengshi: [],

      activeName: '',
      zuixin: false,
      benzhou: false,
      benyue: false,
      shangyue: false,

      top:[],
      listsdata:[],

      total:null,
      currentpage:1,
    }
  },
  methods: {
    pageclick(pp){

      let t = this.$route.query.t
      let cid = this.$route.query.cid
      if(cid){

        if(t){

          window.location.href = 'lists?t='+t+'&cid='+cid+'&page='+pp

        }else{

          window.location.href = 'lists?cid='+cid+'&page='+pp

        }

      }else{

        if(t){

          window.location.href = 'lists?t='+t+'&page='+pp

        }else{

          window.location.href = 'lists?page='+pp

        }

      }

    },
    handleClick() {
      let that = this;
      let cid = this.$route.query.cid
      if (that.activeName == 1) {
        this.zuixin = true;
        this.benzhou = false;
        this.benyue = false;
        this.shangyue = false;
        this.disabled = true;
        if (cid) {
          window.location.href = 'lists?t=1&cid='+cid
        } else {
          window.location.href = 'lists?t=1';
        }
        $.ajax({
          url: '/api/lists',
          type: 'post',
          contentType: 'application/json',
          data: JSON.stringify({ t: gett, page: page }),
          success: (res) => {

            let rr = JSON.parse(res)

            this.listsdata = rr.data
            this.total = rr.count

          }
        })
      } else if (that.activeName == 2) {

        this.zuixin = false;
        this.benzhou = true;
        this.benyue = false;
        this.shangyue = false;
        this.disabled = true;
        if (cid) {
          window.location.href = 'lists?t=2&cid='+cid
        } else {
          window.location.href = 'lists?t=2';
        }
      } else if (that.activeName == 3) {
        this.zuixin = false;
        this.benzhou = false;
        this.benyue = true;
        this.shangyue = false;
        this.disabled = true;
        if (cid) {
          window.location.href = 'lists?t=3&cid='+cid
        } else {
          window.location.href = 'lists?t=3';
        }
      } else if (that.activeName == 4) {
        this.zuixin = false;
        this.benzhou = false;
        this.benyue = false;
        this.shangyue = true;
        this.disabled = true;
        if (cid) {
          window.location.href = 'lists?t=4&cid='+cid
        } else {
          window.location.href = 'lists?t=4';
        }
      }
    },
    submit_zsq() {
      let shouqi = this.csq
      if (shouqi === false) {
        this.zsq = false
        this.csq = true
      }
    },
    submit_csq() {
      let zhankai = this.zsq
      if (zhankai === false) {
        this.zsq = true
        this.csq = false
      }
    },
    submit_zssq() {
      let chengshi = this.cssq
      if (chengshi === false) {
        this.cssq = true
        this.zssq = false
      }
    },
    submit_cssq() {
      this.cssq = false
      this.zssq = true
    }
  },
  created() {
    //所有代码执行前处理

    this.shengids = Number(this.$route.query.cid)

  },
  mounted() {

    let gett = this.$route.query.t
    if(gett){
      gett = Number(gett)
    }else{
      gett = null
    }

    let cid = this.$route.query.cid

    let page = this.$route.query.page
    if(page){
      page = Number(page)
      this.currentpage = Number(page)
    }else{
      page = 1
    }

    if (gett) {
      if (gett == 1) {
        this.zuixin = true;
        this.activeName = '1';
      } else if (gett == 2) {
        this.benzhou = true;
        this.activeName = '2';
      } else if (gett == 3) {
        this.benyue = true;
        this.activeName = '3';
      } else if (gett == 4) {
        this.shangyue = true;
        this.activeName = '4';
      }
    } else {
      this.activeName = '1';
      this.zuixin = true;
    }

    if (cid) {

      let shengtocid = cid.substr(0, 2) + '0000'
      this.shengids = Number(shengtocid)
      this.chengshiids = Number(cid)

      //当前cid是否存在0000
      let cidling = cid.indexOf('0000') !== -1
      if (cidling == true) {
        this.cssq = true
        this.zssq = false
      } else {
        this.cssq = false
        this.zssq = true
      }

      this.$http.post('/api/cityname',{cid:cid}).then(res=>{

        if(res.data.shiname){

          this.shengname = res.data.shengname
          this.chengshiname = res.data.shiname

        }else{

          this.shengname = res.data.shengname

        }

      })

      let cids = cid.indexOf('0000') !== -1
      if (cids === false) {
        //取cid前两位
        let shicids = cid.substr(0, 2) + '0000'

        this.$http.post('/api/selectCity',{cid:shicids}).then(res=>{

          this.chengshi = res.data

        })
        
      } else {

        this.$http.post('/api/selectCity',{cid:cid}).then(res=>{

          this.chengshi = res.data

        })

      }

      if(gett){

        this.$http.post('/api/lists',{cid:cid,page:page,t:gett}).then(res=>{

          this.listsdata = res.data.data
          this.total = res.data.count

          if(this.top = res.data.top){

            this.top = res.data.top

          }

        })

      }else{

        this.$http.post('/api/lists',{cid:cid,page:page}).then(res=>{

          this.listsdata = res.data.data
          this.total = res.data.count

          if(this.top = res.data.top){

            this.top = res.data.top

          }

        })

      }

    }else{

      this.$http.post('/api/lists',{t:gett,page:page}).then(res=>{

        this.listsdata = res.data.data
        this.total = res.data.count
        if(this.top = res.data.top){

          this.top = res.data.top

        }

      })

    }

    this.$http.get('/api/province').then(res=>{

      this.shengfen = res.data
    })

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>


// WEBPACK FOOTER //
// src/components/lists.vue